module.exports = __webpack_public_path__ + "static/media/edit.e7a7a71b.svg";